import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { updateServiceSettings } from "../../api/apiServiceSettings";
import parseError from "../../utils/parseError";

export function useUpdateServiceSettings() {
    const queryClient = useQueryClient();

    const { mutate: updateServiceSettingsMutate, isPending } = useMutation({
        mutationFn: updateServiceSettings,
        onSuccess: (response) => {
            toast.success(response.message || "Updated successfully");
            queryClient.invalidateQueries({ queryKey: ["service-settings"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to update service settings");
        },
    });

    return { updateServiceSettingsMutate, isPending };
}
